import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c13f55b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "introduction-info",
  class: "flex w-100"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "headshot-container h-inherit flex" }, [
  /*#__PURE__*/_createElementVNode("img", {
    id: "headshot",
    src: "/images/jan_bio_old.jpeg",
    alt: "Jan Schaeffer picture"
  })
], -1))
const _hoisted_3 = { class: "intro-info-text flex column" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "light-weight static-large" }, [
  /*#__PURE__*/_createTextVNode(" Janet Schaefer, BCBA-D, LBA "),
  /*#__PURE__*/_createElementVNode("div", { class: "position-title-text mid-weight" }, "CEO and Founder")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "no-wrap-text" }, "are  >", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_router_link, {
        to: "/about",
        class: "about-intro-link text-link-basic midsize-text"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Learn more about who we "),
          _hoisted_5
        ]),
        _: 1
      })
    ])
  ]))
}